import { render } from "./VendorPreviewList.vue?vue&type=template&id=dc8f81e0&scoped=true"
import script from "./VendorPreviewList.vue?vue&type=script&lang=js"
export * from "./VendorPreviewList.vue?vue&type=script&lang=js"

import "./VendorPreviewList.vue?vue&type=style&index=0&id=dc8f81e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8f81e0"]])

export default __exports__